import React, { Component } from "react";
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';

class IndicatorSelector extends Component {
    constructor(props) {
        super(props);
        this.config = props.config;

        this.parentChangeCallback = props.onChange;
        this.state = {
            indicatorMap: this.updateIndicators(this.config),
            activeIndicator : this.config.indicatorConfig.name
        };

        this.onChangeValue = this.onChangeValue.bind(this);
        this.options =[]

        for(let [key, value] of Object.entries(this.state.indicatorMap)){
            this.options.push(<ToggleButton
                key={key}
                value={key}
                >{key}</ToggleButton>);
        }
    }


    updateIndicators(config){
        let hashedIndicators = {};
        hashedIndicators[config.indicatorConfig.name] = config.indicatorConfig;
        let childConfigs = config.indicatorConfig.childConfigs;
        if(childConfigs){
            for(let [key, value] of Object.entries(childConfigs)) {
                hashedIndicators[key] = value;
            }
        }

        return hashedIndicators;
    }

    onChangeValue(key) {
        let config = this.state.indicatorMap[key];
        this.setState({
            activeIndicator :config.name
        })
        this.parentChangeCallback(config.name, config);
    }

    render() {
        return (
            <ToggleButtonGroup type="radio" name="indicator" defaultValue={this.config.indicatorConfig.name} onChange={this.onChangeValue}>
                {this.options}
            </ToggleButtonGroup>
        );
    }
}

export {IndicatorSelector};